<div class="pagebrk">
  <printheaderview [hasimage]="1"></printheaderview>
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

          <div class="row">
            <div class="col-print-11 text-align-center">
              <label class="font-familyhead">Patient Admission Sheet</label>
            </div>
          </div>


          <div class="col-print-12 bordertop">
            <div class="row margin-left-0px">
              <div class="col-print-3">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-8">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px">

              <div class="col-print-12">
                <div class="row margin-left-0px">
                  <label class="margin-bottom-0px font-family font-weight-bold">PERSONAL AND ADMINISTRATION</label>
                </div>
              </div>
              <div class="col-print-7">

                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>

                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Registration No:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>

                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Date Of Birth:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Age:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Adress:</label>
                  </div>
                  <div class="col-print-6">
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                    </div>
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                    </div>
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                    </div>
                    <div class="row margin-left-0px">
                      <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                    </div>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Contact No:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-family font-weight-bold">ADMISSION</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Admission No:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Admission Date:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Provider Incharge:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Admission Reason:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Proposed Treatment:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Ward | Room:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-family font-weight-bold">REFERRAL</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Referral Type:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Referral Name:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Referral Details:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>

                <div class="row margin-left-0px">
                  <div class="col-print-12">
                    <label class="margin-bottom-0px font-family font-weight-bold">INSURANCE</label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Insurance Provider:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Card No:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Approved Status:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-1">
                  </div>
                  <div class="col-print-5">
                    <label class="margin-bottom-0px font-family font-weight-normal">Approved Amount:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
              </div>


            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
  <printcaserecfooterview></printcaserecfooterview>
</div>

